import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

import { HamburgerMenuComponent } from '../shared-components/hamburger-menu/hamburger-menu.component';
import { UserInfoDialogComponent } from '../shared-components/user-info-dialog/user-info-dialog.component';

@Component({
    selector: 'four-oh-four',
    imports: [HamburgerMenuComponent, UserInfoDialogComponent],
    templateUrl: './four-oh-four.component.html',
    styleUrls: ['./four-oh-four.component.scss']
})
export class FourOhFourComponent {
    protected readonly support = environment.support;

    constructor() {}
}
